/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {withDLSTheme} from '../../theme/withDLSTheme';
import {CheckBox as CurrentCheckBox} from './current/CheckBox';
import {CheckBox as LegacyCheckBox} from './legacy/CheckBox';

// This is essential if a client imports the `CheckBox` component using
// `import {CheckBox} from ‘./CheckBox’;`
export const CheckBox = withDLSTheme(LegacyCheckBox, CurrentCheckBox);

export default CheckBox;
